import { render, staticRenderFns } from "./ModalFormGrupo.vue?vue&type=template&id=70f4f2d4"
import script from "./ModalFormGrupo.vue?vue&type=script&lang=js"
export * from "./ModalFormGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports